import type { LoanApplicationInput } from "@/generated/graphql"
import { map } from "nanostores"
import { type MapStore } from "nanostores/map"

interface LoanState {
  updates: LoanApplicationInput
  sentToServer: LoanApplicationInput[]
}
type LoanStateCache = Record<string, MapStore<LoanState>>

const _loanStates: LoanStateCache = {}
export function getLoanUpdateStore(loanId: string) {
  if (_loanStates[loanId]) {
    return _loanStates[loanId]
  }

  return (_loanStates[loanId] = map({ updates: {}, sentToServer: [] }))
}

export function addLoanUpdates(loanId: string, input: LoanApplicationInput) {
  const map = getLoanUpdateStore(loanId)
  map.setKey("updates", { ...map.get().updates, ...input })
}

export function setLoanUpdates(loanId: string, input: LoanApplicationInput) {
  const map = getLoanUpdateStore(loanId)
  map.setKey("updates", input)
}

export function pushToServer(loanId: string) {
  const map = getLoanUpdateStore(loanId)
  const updates = map.get().updates
  const sentToServer = map.get().sentToServer || []
  map.set({
    updates: {},
    sentToServer: [...sentToServer, updates],
  })
  return updates
}

export function updatedFromServer(loanId: string) {
  const map = getLoanUpdateStore(loanId)
  map.setKey("sentToServer", [])
}
